import React, { Fragment, useEffect, useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import DayWisePerformance from "./DayWisePerformance";
import TopHeader from "../../../../Components/TopHeader/TopHeader";
import { useLocation, useNavigate } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import { useFormik } from "formik";
import dayjs from "dayjs";
import * as Yup from "yup";
import PerformanceDailyGraph from "./PerformanceMonthlyGraph";
import CustomerSelection from "./CustomerSelection";
import FUNCTIONS_URLS from "../../../../Config/functions";
import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  setDoc,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { DATABASE } from "../../../../Config/firebase";
import { toast } from "react-toastify";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import axios from "axios";
import { getFundRules, getCommissionRate } from '../../../../Utils/fundRules';
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const monthLocalNoon = (value, { end = false } = {}) => {
  const d = dayjs(value);
  if (!d.isValid()) return new Date();
  if (end) {
    return new Date(d.year(), d.month(), d.daysInMonth(), 12, 0, 0);
  }
  return new Date(d.year(), d.month(), 1, 12, 0, 0);
};

const freezeTsToDayjs = (ts) => {
  if (!ts) return null;
  try {
    if (typeof ts.toDate === "function") {
      const parsed = dayjs(ts.toDate());
      return parsed.isValid() ? parsed : null;
    }
    const seconds = ts.seconds ?? ts._seconds;
    if (seconds != null) {
      const parsed = dayjs(new Date(seconds * 1000));
      return parsed.isValid() ? parsed : null;
    }
    const parsed = dayjs(ts);
    return parsed.isValid() ? parsed : null;
  } catch {
    return null;
  }
};
const AddMonthlyGraph = () => {
  const navigate = useNavigate();
  const [isLoadingProgress, setIsLoadingProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [total_Monthly_percantage, setTotal_monthly_percantage] = useState(0);
  const [customerList, setCustomerList] = useState([]);
  const [multipleUsersEntryList, setMultipleUsersEntryList] = useState([]);
  
  const [activeStep, setActiveStep] = useState(parseInt(sessionStorage.getItem("activeStep")) || 0);
  const [ledgers, setLedgers] = useState([]);
  const [isNotify, setIsNotify] = useState([]);
  // Removed repetitive console.logs - they were causing performance issues

  const steps = ["Days Performance", "Month Graph", "Users Selection"];
  const fetchCustomerList = async () => {
    setIsLoading(true);
    const customerQuery = query(
      collection(DATABASE, "users"),
      orderBy("registered_date", "desc"),
      where("status", "==", 1),
    );
    onSnapshot(
      customerQuery,
      (snapshot) => {
        const data = snapshot.docs
          .map((doc, index) => ({
            rowid: index + 1,
            id: doc.id,
            ...doc.data(),
          }))
          .filter((doc) => doc.role === 1);
        setCustomerList(data);
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching customers:", error);
        setIsLoading(false);
      }
    );
  };
  useEffect(() => {
    fetchCustomerList();
  }, []);
  const handleNext = async () => {
    setIsLoadingProgress(0);
    let progress = 0;
    const progressInterval = setInterval(() => {
      progress += 1;
      setIsLoadingProgress(progress);
      if (progress >= 100) {
        clearInterval(progressInterval);
      }
    }, 30);
    if (activeStep === 0) {
      const step = 100 / customerList?.length;
      let multipleUsersEntry = [];
      try {
        // Fetch fund rules once for all users
        const fundRules = await getFundRules();
        
        const existingLedgers = ledgers?.filter((ledger) =>
          customerList?.some((customer) => (customer?.doc_id || customer?.id) === ledger?.user_id)
        );
        const userPromises = customerList?.map(async (userID) => {
          const userDocId = userID?.doc_id || userID?.id;
          const userLedgers = existingLedgers
            ?.filter((e) => e?.user_id === userDocId)
            ?.map((entry) => {
              const entryDate =
                entry?.date instanceof Timestamp
                  ? entry?.date.toDate()
                  : entry?.created_at?.toDate?.() || new Date(entry?.date);
              return {
                ...entry,
                __entryDate: entryDate ? dayjs(entryDate) : null,
              };
            })
            ?.filter((entry) => entry.__entryDate);

          const sortedUserLedgers = userLedgers
            ?.slice()
            ?.sort((a, b) => a.__entryDate.valueOf() - b.__entryDate.valueOf());

          const userNetBalance = await getCustomerDetails(
            sortedUserLedgers?.[0]?.user_id || userDocId
          );
          
          console.log(`\n🔍 User: ${userID?.full_name || userID?.name || userDocId}`);
          console.log(`   User doc_id: ${userID?.doc_id}, id: ${userID?.id}, using: ${userDocId}`);
          console.log(`   Ledgers count: ${sortedUserLedgers?.length || 0}`);
          if (sortedUserLedgers?.length > 0) {
            console.log(`   First ledger date: ${sortedUserLedgers[0].__entryDate?.format("YYYY-MM-DD HH:mm:ss")}`);
            console.log(`   Last ledger date: ${sortedUserLedgers[sortedUserLedgers.length - 1].__entryDate?.format("YYYY-MM-DD HH:mm:ss")}`);
          }
          console.log(`   Net balance: $${userNetBalance}`);
          

          // Helper function to get conclusion_date with fallback logic
          const getConclusionDate = (withdrawal) => {
            // If has conclusion_date, use it
            if (withdrawal.conclusion_date) {
              return dayjs(withdrawal.conclusion_date.toDate ? 
                withdrawal.conclusion_date.toDate() : 
                withdrawal.conclusion_date);
            }
            
            // Fallback based on status
            const baseDate = withdrawal.request_date 
              ? dayjs(withdrawal.request_date.toDate ? withdrawal.request_date.toDate() : withdrawal.request_date)
              : withdrawal.__entryDate;
            
            if (withdrawal.request_status === 5) {
              // Paid: 1 day after requested/accepted
              return baseDate.add(1, 'day');
            } else if (withdrawal.request_status === 4 || withdrawal.request_status === 6) {
              // Rejected/Cancelled: 1 day after (money returned next day)
              return baseDate.add(1, 'day');
            }
            
            // For other statuses, return null (not concluded yet)
            return null;
          };

          // Helper function to check if withdrawal was active (money out of account) on a specific date
          const isWithdrawalActiveOnDate = (withdrawal, currentDate) => {
            const withdrawalDate = withdrawal.__entryDate; // Creation date
            const status = withdrawal.request_status;
            const conclusionDate = getConclusionDate(withdrawal);
            
            // If withdrawal hasn't been created yet on this day, it's not active
            if (withdrawalDate.isAfter(currentDate, 'day')) {
              return false;
            }
            
            // If paid (status 5), always active from creation date onwards
            if (status === 5) {
              return true;
            }
            
            // If rejected or cancelled (status 4 or 6)
            if (status === 4 || status === 6) {
              if (conclusionDate) {
                // Has conclusion_date: money returned on conclusion date
                return conclusionDate.isAfter(currentDate, 'day');
              } else {
                // No conclusion_date: assume concluded next day (fallback)
                return withdrawalDate.add(1, 'day').isAfter(currentDate, 'day');
              }
            }
            
            // For other statuses (0, 1, 2, 3, null), active if created before or on this day
            // These are pending withdrawals - money is out of account
            return true;
          };

          // ===== Account Operations Freeze — performance mensal POR DIA =====
          // Só os dias efetivamente congelados deixam de performar (mesma granularidade
          // por dia que os saques). Um cliente congelado 2-5 dias NÃO perde o mês todo.
          // Ver docs/ACCOUNT_OPERATIONS_FREEZE.md §6.
          let freezeHistory = Array.isArray(userID?.account_operations_freeze_history)
            ? userID.account_operations_freeze_history
            : [];
          let frozenFlag = userID?.account_operations_frozen === true;
          let frozenAtFlag = userID?.account_operations_frozen_at || null;

          try {
            const freshUserSnap = await getDoc(doc(DATABASE, "users", userDocId));
            if (freshUserSnap.exists()) {
              const freshUser = freshUserSnap.data();
              if (Array.isArray(freshUser.account_operations_freeze_history)) {
                freezeHistory = freshUser.account_operations_freeze_history;
              }
              frozenFlag = freshUser.account_operations_frozen === true;
              frozenAtFlag = freshUser.account_operations_frozen_at || frozenAtFlag;
            }
          } catch (freezeReadError) {
            console.warn(`   ⚠️ Could not refresh freeze history for ${userDocId}:`, freezeReadError);
          }

          if (!freezeHistory.length && frozenFlag) {
            freezeHistory = [{ frozen_at: frozenAtFlag, unfrozen_at: null }];
          }

          // Um dia conta como congelado se currentDate >= frozen_at (dia) E
          // (unfrozen_at é null OU currentDate < unfrozen_at (dia)).
          // → Dia do freeze não performa; dia do unfreeze volta a performar.
          const isFrozenOnDate = (currentDate) => {
            const fromHistory = freezeHistory.some((interval) => {
              if (!interval) return false;
              const start = freezeTsToDayjs(interval.frozen_at);
              if (!start) return false;
              if (currentDate.isBefore(start, 'day')) return false;
              const end = freezeTsToDayjs(interval.unfrozen_at);
              if (!end) return true; // intervalo aberto → congelado do início em diante
              return currentDate.isBefore(end, 'day');
            });
            if (fromHistory) return true;
            // Cinto: interruptor ligado mas histórico vazio/ilegível → não performa
            // a partir de frozen_at (ou o mês todo se a data faltar).
            if (!frozenFlag) return false;
            const start = freezeTsToDayjs(frozenAtFlag);
            if (!start) return true;
            return !currentDate.isBefore(start, 'day');
          };

          // Get all withdrawals (no filter by status yet - we'll filter by active status per day)
          const allWithdrawals = (sortedUserLedgers || []).filter(
            e => e.transection_type === 2
          );

          // Filter approved transactions for deposits (keep existing logic)
          const approvedLedgers = (sortedUserLedgers || []).filter(
            e => !e.request_status || e.request_status === 2
          );

          let totalMonthlyProfitLoss = 0;
          let closingPercentageAccumulated = 0;
          const graphPoints = [];

          const totalMonthlyPercentage =
            formik?.values?.dayWisePerformance?.select_days.reduce(
              (acc, dayData) => acc + (parseFloat(dayData?.percentage) || 0),
              0
            );
          const daysInMonth = formik?.values?.dayWisePerformance?.select_days.length;
          const day_avg_percentage = totalMonthlyPercentage / daysInMonth;

          // 1. Try to get balance from previous month's closing
          const previousMonth = dayjs(formik?.values?.dayWisePerformance?.select_Month)
            .subtract(1, 'month');
          const previousMonthNum = previousMonth.month();
          const previousYear = previousMonth.year();

          let openingBalance = 0;

          // Check monthly_closings for previous month
          const closingsRef = collection(DATABASE, 'monthly_closings');
          const closingsQuery = query(
            closingsRef,
            where('user_id', '==', userDocId),
            where('closing_month', '==', previousMonthNum),
            where('closing_year', '==', previousYear)
          );
          const closingsSnap = await getDocs(closingsQuery);

          if (!closingsSnap.empty) {
            // Use balance_after_commission from previous month's closing
            openingBalance = parseFloat(closingsSnap.docs[0].data()?.closing_balance || 0);
            console.log(`   💰 Opening from monthly_closings: $${openingBalance.toFixed(2)}`);
          } else {
            // Fallback: Look for performance ledger in the previous month (September)
            const selectedMonthStart = dayjs(formik?.values?.dayWisePerformance?.select_Month)
              .startOf('month');
            const previousMonthStart = previousMonth.startOf('month');
            const previousMonthEnd = previousMonth.endOf('month');
            
            // First, try to find performance ledger (type=3) in September
            const performanceLedgersInPrevMonth = (sortedUserLedgers || []).filter(
              e => e.transection_type === 3 && 
                   e.__entryDate.isSameOrAfter(previousMonthStart, 'day') &&
                   e.__entryDate.isSameOrBefore(previousMonthEnd, 'day')
            );
            
            if (performanceLedgersInPrevMonth.length > 0) {
              // Use the LAST performance ledger in September (the closing)
              const septemberClosing = performanceLedgersInPrevMonth[performanceLedgersInPrevMonth.length - 1];
              openingBalance = parseFloat(septemberClosing?.current_balance ?? septemberClosing?.balance ?? 0);
              console.log(`   💰 Opening from Sept performance ledger (${septemberClosing.__entryDate.format('MMM D')}): $${openingBalance.toFixed(2)}`);
            } else {
              // Last resort: Get the very last ledger before October (any type)
              const allLedgersBeforeMonth = (sortedUserLedgers || []).filter(
                e => e.__entryDate.isBefore(selectedMonthStart, 'day')
              );
              
              if (allLedgersBeforeMonth.length > 0) {
                const lastLedger = allLedgersBeforeMonth[allLedgersBeforeMonth.length - 1];
                openingBalance = parseFloat(lastLedger?.current_balance ?? lastLedger?.balance ?? 0);
                console.log(`   💰 Opening from last ledger before Oct (${lastLedger.__entryDate.format('MMM D')}, type=${lastLedger.transection_type}): $${openingBalance.toFixed(2)}`);
              } else {
                console.log(`   💰 Opening: $0 (new client, no previous ledgers)`);
              }
            }
          }

          // Daily calculation with D+1/D0 logic
          let previousBalance = openingBalance;
          let frozenDays = 0;

          formik?.values?.dayWisePerformance?.select_days.forEach((dayData, index) => {
            const day = index + 1;
            const currentDate = dayjs(formik?.values?.dayWisePerformance?.select_Month).date(day);
            const currentPercentage = parseFloat(dayData?.percentage) || 0;

            // STEP 1: Apply withdrawals BEFORE performance (D0 - trading stops immediately)
            // Reduce balance for withdrawals created on this day that were active (money out of account)
            // Active means: not yet concluded as rejected (4) or cancelled (6) on this day
            
            // DEBUG: Check all withdrawals for Claudiney on this day
            if (userDocId === 'GLSLmb8pTnafjtXj0PvTOsVlqYF2') {
              const allWithdrawalsOnThisDay = allWithdrawals.filter(w => 
                w.__entryDate.isSame(currentDate, 'day')
              );
              if (allWithdrawalsOnThisDay.length > 0) {
                console.log(`   🔍 DEBUG CLAUDINEY: Day ${day} (${currentDate.format('MMM D')}): Found ${allWithdrawalsOnThisDay.length} withdrawals on this day`);
                allWithdrawalsOnThisDay.forEach(w => {
                  const isActive = isWithdrawalActiveOnDate(w, currentDate);
                  console.log(`      Withdrawal: $${w.new_txn_amount} (status: ${w.request_status}, doc_id: ${w.doc_id || 'N/A'}, isActive: ${isActive})`);
                });
              }
            }
            
            const withdrawalsCreatedToday = allWithdrawals.filter(w => 
              w.__entryDate.isSame(currentDate, 'day') &&
              isWithdrawalActiveOnDate(w, currentDate)
            );
            
            withdrawalsCreatedToday.forEach(w => {
              // DEBUG: Log withdrawals for Claudiney
              if (userDocId === 'GLSLmb8pTnafjtXj0PvTOsVlqYF2') {
                console.log(`   🔍 DEBUG CLAUDINEY: Day ${day} (${currentDate.format('MMM D')}): Applying withdrawal $${w.new_txn_amount} (status: ${w.request_status}, doc_id: ${w.doc_id || 'N/A'})`);
                console.log(`      Balance before: $${previousBalance.toFixed(2)}`);
              }
              const amount = parseFloat(w.new_txn_amount || 0);
              previousBalance -= amount;
              if (userDocId === 'GLSLmb8pTnafjtXj0PvTOsVlqYF2') {
                console.log(`      Balance after: $${previousBalance.toFixed(2)}`);
              }
            });

            // STEP 2: Calculate performance on current balance
            // Account Operations Freeze: dias dentro de um intervalo de freeze NÃO performam.
            const isFrozenToday = isFrozenOnDate(currentDate);
            if (isFrozenToday) frozenDays += 1;
            const dailyProfitLoss = isFrozenToday ? 0 : (previousBalance * day_avg_percentage) / 100;
            totalMonthlyProfitLoss += dailyProfitLoss;
            
            const openingBalanceForDay = previousBalance;
            // NOTE: Do NOT add dailyProfitLoss to previousBalance
            // Performance is only reported at month-end, not compounded daily

            // STEP 3: Apply deposits AFTER performance (D+1 - starts trading next day)
            const depositsToday = approvedLedgers.filter(
              e => e.transection_type === 0 && e.__entryDate.isSame(currentDate, 'day')
            );
            depositsToday.forEach(d => {
              // DEBUG: Log deposits for Claudiney
              if (userDocId === 'GLSLmb8pTnafjtXj0PvTOsVlqYF2') {
                console.log(`   🔍 DEBUG CLAUDINEY: Day ${day} (${currentDate.format('MMM D')}): Applying deposit $${d.new_txn_amount}`);
                console.log(`      Balance before: $${previousBalance.toFixed(2)}`);
              }
              const amount = parseFloat(d.new_txn_amount || 0);
              previousBalance += amount;
              if (userDocId === 'GLSLmb8pTnafjtXj0PvTOsVlqYF2') {
                console.log(`      Balance after: $${previousBalance.toFixed(2)}`);
              }
            });

            const closingBalance = previousBalance;

              graphPoints.push({
                closing_balance: closingBalance,
              opening_balance: openingBalanceForDay,
                amount: currentPercentage,
              opening_percentage: index === 0 ? 0 : closingPercentageAccumulated,
                closing_percentage: currentPercentage,
                date: Timestamp.fromDate(currentDate.toDate()),
              open: parseFloat(dayData?.opening) || 0,
              close: parseFloat(dayData?.closing) || 0,
              high: parseFloat(dayData?.highest) || 0,
              low: parseFloat(dayData?.lowest) || 0,
                volume: 0,
              });

              closingPercentageAccumulated = currentPercentage;
          });

          // DEBUG: Log balance after daily loop (before final calculation)
          if (userDocId === 'GLSLmb8pTnafjtXj0PvTOsVlqYF2') { // Claudiney
            console.log(`\n   🔍 DEBUG CLAUDINEY: After daily loop:`);
            console.log(`      openingBalance (original): $${openingBalance.toFixed(2)}`);
            console.log(`      previousBalance (final after loop): $${previousBalance.toFixed(2)}`);
            console.log(`      Difference: $${(previousBalance - openingBalance).toFixed(2)}`);
          }

          // Calculate "saldo após depósitos" = balance initial + approved deposits - approved withdrawals
          const selectedMonthStart = dayjs(formik?.values?.dayWisePerformance?.select_Month).startOf('month');
          const selectedMonthEnd = dayjs(formik?.values?.dayWisePerformance?.select_Month).endOf('month');
          
          const depositsInMonth = approvedLedgers.filter(
            e => e.transection_type === 0 && 
                 e.__entryDate.isSameOrAfter(selectedMonthStart, 'day') &&
                 e.__entryDate.isSameOrBefore(selectedMonthEnd, 'day')
          );
          
          // Total Withdrawals: Count paid withdrawals (status 5) OR withdrawals with null status within the month
          // Note: Null status is for old withdrawals before request_status field was implemented
          // These are considered paid because they exist in the ledger
          
          // DEBUG: Log all withdrawals in the month before filtering
          console.log(`\n   🔍 DEBUG: All withdrawals in month (before status filter):`);
          const allWithdrawalsInMonth = allWithdrawals.filter(
            e => e.__entryDate.isSameOrAfter(selectedMonthStart, 'day') &&
                 e.__entryDate.isSameOrBefore(selectedMonthEnd, 'day')
          );
          allWithdrawalsInMonth.forEach(w => {
            console.log(`      ${w.__entryDate.format('MMM D')}: $${w.new_txn_amount} (status: ${w.request_status}, type: ${typeof w.request_status}, doc_id: ${w.doc_id || 'N/A'})`);
          });
          
          const withdrawalsInMonth = allWithdrawals.filter(
            e => {
              const isInMonth = e.__entryDate.isSameOrAfter(selectedMonthStart, 'day') &&
                                e.__entryDate.isSameOrBefore(selectedMonthEnd, 'day');
              
              if (!isInMonth) return false;
              
              // Check status: Paid (5) OR null/undefined (old paid withdrawals)
              // Use == instead of === to handle string "5" vs number 5
              const isPaid = e.request_status == 5 || e.request_status === null || e.request_status === undefined;
              
              // DEBUG: Log withdrawals that are being excluded
              if (!isPaid) {
                console.log(`      ⚠️ EXCLUDED: ${e.__entryDate.format('MMM D')}: $${e.new_txn_amount} (status: ${e.request_status}, type: ${typeof e.request_status})`);
              }
              
              return isPaid;
            }
          );
          
          console.log(`   📥 Deposits in month: ${depositsInMonth.length}`);
          depositsInMonth.forEach(d => {
            console.log(`      ${d.__entryDate.format('MMM D')}: $${d.new_txn_amount}`);
          });
          
          console.log(`   📤 Paid withdrawals in month: ${withdrawalsInMonth.length}`);
          withdrawalsInMonth.forEach(w => {
            console.log(`      ${w.__entryDate.format('MMM D')}: $${w.new_txn_amount} (status: ${w.request_status}, type: ${typeof w.request_status})`);
          });
          
          const totalWithdrawalsAmount = withdrawalsInMonth.reduce((sum, w) => sum + parseFloat(w.new_txn_amount || 0), 0);
          console.log(`   💰 Total withdrawals amount: $${totalWithdrawalsAmount.toFixed(2)}`);
          
          const approvedDepositsOctober = depositsInMonth.reduce((sum, d) => sum + parseFloat(d.new_txn_amount || 0), 0);
          
          // DEBUG: Calculate withdrawals with detailed logging
          let approvedWithdrawalsOctober = 0;
          console.log(`\n   🔍 DEBUG: Calculating approvedWithdrawalsOctober:`);
          withdrawalsInMonth.forEach((w, index) => {
            const amount = parseFloat(w.new_txn_amount || 0);
            approvedWithdrawalsOctober += amount;
            console.log(`      [${index + 1}] ${w.__entryDate.format('MMM D')}: $${amount.toFixed(2)} (status: ${w.request_status}, new_txn_amount: ${w.new_txn_amount}, type: ${typeof w.new_txn_amount}) -> Running total: $${approvedWithdrawalsOctober.toFixed(2)}`);
          });

          // DEBUG: Log Net Balance calculation
          console.log(`\n   🔍 DEBUG: Net Balance Calculation:`);
          console.log(`      Opening Balance: $${openingBalance.toFixed(2)}`);
          console.log(`      Total Deposits: $${approvedDepositsOctober.toFixed(2)}`);
          console.log(`      Total Withdrawals: $${approvedWithdrawalsOctober.toFixed(2)}`);
          console.log(`      Calculation: $${openingBalance.toFixed(2)} + $${approvedDepositsOctober.toFixed(2)} - $${approvedWithdrawalsOctober.toFixed(2)}`);
          
          // DEBUG: Check if previousBalance was modified during daily loop
          console.log(`\n   🔍 DEBUG: Balance after daily loop:`);
          console.log(`      previousBalance (final after loop): $${previousBalance.toFixed(2)}`);
          console.log(`      Difference from openingBalance: $${(previousBalance - openingBalance).toFixed(2)}`);
          
          // DEBUG: Calculate what the balance should be after applying deposits and withdrawals
          const expectedBalanceAfterTransactions = openingBalance + approvedDepositsOctober - approvedWithdrawalsOctober;
          console.log(`      Expected balance (opening + deposits - withdrawals): $${expectedBalanceAfterTransactions.toFixed(2)}`);
          console.log(`      Actual previousBalance: $${previousBalance.toFixed(2)}`);
          console.log(`      Difference: $${(previousBalance - expectedBalanceAfterTransactions).toFixed(2)}`);
          
          // Calculate saldoAposDepositos = openingBalance + deposits - withdrawals
          // This should match the expected balance after all transactions
          const saldoAposDepositos = openingBalance + approvedDepositsOctober - approvedWithdrawalsOctober;
          
          console.log(`      Net Balance (saldoAposDepositos): $${saldoAposDepositos.toFixed(2)}`);

          // Get dynamic commission rate from Fund Rules
          const commissionRate = await getCommissionRate(totalMonthlyProfitLoss, fundRules);

          const profitToUser = (parseFloat(totalMonthlyProfitLoss) * (100 - commissionRate)) / 100;

          const isFullWithdrawal = (sortedUserLedgers || []).some(
            (entry) => entry.transection_type === 2 && 
              parseFloat(entry.new_txn_amount || 0) === openingBalance
          );

          const grossPerformancePercentage = saldoAposDepositos !== 0
            ? (parseFloat(totalMonthlyProfitLoss) * 100) / saldoAposDepositos
            : 0;

          const percentageAfterCommission = saldoAposDepositos !== 0
            ? (parseFloat(profitToUser) * 100) / saldoAposDepositos
            : 0;

          // Skip users with net zero balance (opening + deposits - withdrawals = 0)
          if (Math.abs(saldoAposDepositos) < 0.01) {
            console.log(`\n📊 ${userID?.full_name || userDocId}:`);
            console.log(`   ⏭️  SKIPPED: User has $0 net balance after transactions (Opening: $${openingBalance.toFixed(2)}, Deposits: $${approvedDepositsOctober.toFixed(2)}, Withdrawals: $${approvedWithdrawalsOctober.toFixed(2)})`);
            setIsLoadingProgress((prev) => Math.min(prev + step, 100));
            return;
          }

          console.log(`\n📊 ${userID?.full_name || userDocId}:`);
          console.log(`   Opening Balance: $${openingBalance.toFixed(2)}`);
          console.log(`   Approved Deposits: $${approvedDepositsOctober.toFixed(2)}`);
          console.log(`   Approved Withdrawals: $${approvedWithdrawalsOctober.toFixed(2)}`);
          console.log(`   Saldo após depósitos: $${saldoAposDepositos.toFixed(2)}`);
          console.log(`   Total Profit: $${totalMonthlyProfitLoss.toFixed(2)}`);
          console.log(`   Gross %: ${grossPerformancePercentage.toFixed(4)}%`);
          console.log(`   Frozen days: ${frozenDays}/${daysInMonth} (flag=${frozenFlag}, history=${freezeHistory.length})`);
          console.log(`   Commission Rate: ${commissionRate}%`);
          console.log(`   Net %: ${percentageAfterCommission.toFixed(4)}%`);

          const entryToPush = {
            doc_id: `${userDocId}_${dayjs().format("YYYYMMDDHHmmss")}`,
            start_date: Timestamp.fromDate(
              monthLocalNoon(formik?.values?.dayWisePerformance?.select_Month)
            ),
            end_date: Timestamp.fromDate(
              monthLocalNoon(formik?.values?.dayWisePerformance?.select_Month, { end: true })
            ),
            current_month_date: Timestamp.fromDate(
              // Use custom ledger date if provided, otherwise default to next month start
              (formik?.values?.dayWisePerformance?.ledgerDate 
                ? dayjs(formik.values.dayWisePerformance.ledgerDate)
                : dayjs(monthLocalNoon(formik?.values?.dayWisePerformance?.select_Month)).add(1, "month")
              ).toDate()
            ),
            graph_month: formik?.values?.dayWisePerformance?.select_Month.month(),
            chart_month:
              formik?.values?.dayWisePerformance?.select_Month.month() + 1,
            graph_month_date: Timestamp.fromDate(
              monthLocalNoon(formik?.values?.dayWisePerformance?.select_Month)
            ),
            graph_year: formik?.values?.dayWisePerformance?.select_Month.year(),
            graph_points: graphPoints,
            total_Monthly_Profit_Loss: parseFloat(
              totalMonthlyProfitLoss?.toFixed(2)
            ),
            user_id: userID,
            total_Monthly_percantage: totalMonthlyPercentage,
            day_avg_percentage,
            amount_before_performance: isFullWithdrawal ? 0 : openingBalance,
            starting_balance: openingBalance,
            total_deposits: approvedDepositsOctober,
            total_withdrawals: approvedWithdrawalsOctober,
            effective_capital: saldoAposDepositos, // Alternative field for Net Balance display
            gross_performance_percentage: grossPerformancePercentage,
            gross_performance_balance:
              parseFloat(totalMonthlyProfitLoss) + openingBalance,
            fiddux_commission_percentage: commissionRate,
            fiddux_commission: parseFloat(totalMonthlyProfitLoss * commissionRate) / 100,
            percentage_after_commission: percentageAfterCommission,
            balance_after_commission: saldoAposDepositos + profitToUser,
            profit_to_user: profitToUser,
            net_balance: openingBalance,
          };
          multipleUsersEntry.push(entryToPush);
          console.log(`   ✅ Pushed entry for ${userID?.full_name || userDocId}, array length now: ${multipleUsersEntry.length}`);
          setIsLoadingProgress((prev) => Math.min(prev + step, 100));
        });
        await Promise.all(userPromises);
        await new Promise((resolve) => setTimeout(resolve, 100));
        console.log(`\n✅ Total users processed: ${multipleUsersEntry.length}`);
        console.log('multipleUsersEntry:', multipleUsersEntry);
        setMultipleUsersEntryList(multipleUsersEntry);
      } catch (error) {
        console.error("Error processing users:", error);
      } finally {
        clearInterval(progressInterval);
        setTimeout(() => setIsLoadingProgress(100), 500);
      }
    }
    const nextStep = Math.min(activeStep + 1, steps.length - 1);
    setActiveStep(nextStep);
    sessionStorage.setItem("activeStep", nextStep);
  };
  const handleBack = () => {
    const prevStep = Math.max(activeStep - 1, 0);
    setActiveStep(prevStep);
    sessionStorage.setItem("activeStep", prevStep);
  };
  const isFormValid = () => {
    const hasUsers = formik.values.select_user.length > 0;
    return hasUsers;
  };
  const isStepValid = (step) => {
    switch (step) {
      case 0:
        return formik.values.dayWisePerformance.select_days.some(
          (day) => day.percentage > 0
        );
      case 1:
        return true;
      case 2:
        return formik.values.select_user.length > 0;
      default:
        return false;
    }
  };
  const getLedgersList = () => {
    setIsLoading(true);
    const sDate = new Date(formik?.values?.dayWisePerformance?.select_Month);
    const q = query(
      collection(DATABASE, "ledgers")
    );
    return onSnapshot(
      q,
      (querySnapshot) => {
        const allData = querySnapshot.docs
          .filter((doc) => doc.data())
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        setLedgers(allData);
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching ledgers:", error);
        setIsLoading(false);
      }
    );
  };
  const getCustomerDetails = async (ID) => {
    setIsLoading(true);
    try {
      const transactionRef = collection(DATABASE, "users");
      const q = query(
        transactionRef,
        where("doc_id", "==", ID),
        where("status", "==", 1)
      );
      const querySnapshot = await getDocs(q);
      const data = querySnapshot?.docs.map((doc) => doc?.data());
      if (data?.length) {
      return data[0]?.net_balance;
      }
      // Fallback: try direct document lookup
      const docRef = doc(DATABASE, "users", ID);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return docSnap.data()?.net_balance;
      }
      return 0;
    } catch (error) {
      console.error("Error fetching customer details:", error);
      return 0;
    } finally {
      setIsLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      select_user: [],
      dayWisePerformance: {
        select_Month: dayjs().startOf("month"),
        select_days: Array.from({ length: dayjs().daysInMonth() }, (_, i) => ({
          day: i + 1,
          percentage: 0,
          opening: 0,
          closing: 0,
          highest: 0,
          lowest: 0,
        })),
        // Optional: Custom date/time for ledger entry (defaults to next month start if not set)
        ledgerDate: null,
      },
    },
    validationSchema: Yup.object({
      select_user: Yup.array().min(1, "At least one user is required."),
      dayWisePerformance: Yup.object({
        select_days: Yup.array().of(
          Yup.object({
            percentage: Yup.number()
              .required("Percentage is required.")
              .typeError("Must be a number")
              .min(-100, "Percentage cannot be less than -100.")
              .max(100, "Percentage cannot be more than 100."),
          })
        ),
      }),
    }),

    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      setIsLoadingProgress(10);
      try {
        // FIX 04/05/2026: ledgerDate escolhido na 3a tela (DateTimePicker) tem prioridade absoluta
        // sobre current_month_date calculado no Step 0 (que pode estar com fallback errado: 01/{m+1} 00:00).
        // Aplicado a ledgers.date, transection_requests.date/request_approval_time e monthly_closings.date.
        // Refs: docs/RELATORIOS/PLANO_CORRECAO_LEDGERDATE_2026-05-04.md
        const finalLedgerDate = values?.dayWisePerformance?.ledgerDate
          ? Timestamp.fromDate(dayjs(values.dayWisePerformance.ledgerDate).toDate())
          : null;

        console.log("📅 [Fechamento] finalLedgerDate:", finalLedgerDate?.toDate?.());
        console.log("📅 [Fechamento] Será aplicado a ledgers.date, transection_requests.date e monthly_closings.date");

        let multipleUsersLedgers = [];
        let transectionUsers = [];
        let monthly_closing_user = [];
        let matchingEntries = [];
        console.log('🔍 DEBUG: Starting monthly closure submission...');
        console.log(`   Selected users count: ${values?.select_user?.length || 0}`);
        console.log(`   multipleUsersEntryList count: ${multipleUsersEntryList?.length || 0}`);
        
        const setDocPromises = values?.select_user?.map(
          async (userId, index) => {
            // Try multiple ID formats for matching
            const userDocId = userId?.doc_id || userId?.id || userId;
            
            // DEBUG: Log ID matching attempt
            console.log(`🔍 DEBUG: Looking for user ${userDocId} in multipleUsersEntryList...`);
            console.log(`   select_user entry:`, userId);
            console.log(`   Extracted userDocId: ${userDocId}`);
            
            // Try multiple ID formats for matching
            // IMPORTANT: Some users have both doc_id and id, and they might be different
            // We need to check both the userDocId (from select_user) against both doc_id and id in the entry
            const matchingEntry = multipleUsersEntryList?.find((entry) => {
              const entryDocId = entry.user_id?.doc_id;
              const entryId = entry.user_id?.id;
              const entryUserId = entryDocId || entryId || entry.user_id;

              // Check if userDocId matches either doc_id or id in the entry
              const matches = entryDocId === userDocId || entryId === userDocId || entryUserId === userDocId;
              
              if (matches) {
                console.log(`   ✅ Found match! Entry user_id:`, entry.user_id, `profit_to_user: $${entry.profit_to_user?.toFixed(2) || '0.00'}`);
                console.log(`      Matching: userDocId=${userDocId} matches entry.doc_id=${entryDocId} or entry.id=${entryId}`);
              }
              return matches;
            });

            if (!matchingEntry) {
              // DEBUG: Log all available entries for comparison
              console.log(`   ❌ No match found. Available entries in multipleUsersEntryList:`);
              multipleUsersEntryList?.forEach((entry, idx) => {
                const entryUserId = entry.user_id?.doc_id || entry.user_id?.id || entry.user_id;
                console.log(`      [${idx}] Entry user_id:`, entry.user_id, `-> Extracted: ${entryUserId}, profit_to_user: $${entry.profit_to_user?.toFixed(2) || '0.00'}`);
              });
              
              // User was selected in step 3 but skipped in step 2 (likely $0 balance)
              const userName = userId?.full_name || userId?.email || userDocId;
              console.warn(`⚠️ Skipping user ${userDocId} (${userName}): No matching entry found in multipleUsersEntryList. This user was likely skipped in step 2 due to $0 balance.`);
              return Promise.resolve(); // Skip this user, continue with others
            }

            // Fetch user data to ensure we have full_name and email
            let userName = userId?.full_name || userId?.name || "Unknown";
            let userEmail = userId?.email || "Unknown";
            
            // If userId doesn't have the data, try to get it from the users collection
            if (!userName || userName === "Unknown" || !userEmail || userEmail === "Unknown") {
              try {
                const userDocRef = doc(DATABASE, "users", userDocId);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                  const userData = userDocSnap.data();
                  userName = userData?.full_name || userData?.name || userName || "Unknown";
                  userEmail = userData?.email || userEmail || "Unknown";
                }
              } catch (error) {
                console.error(`Error fetching user data for ${userDocId}:`, error);
              }
            }
            
            // Use the same ID that was used for matching (doc_id if available, otherwise id)
            const matchedUserId = matchingEntry.user_id?.doc_id || matchingEntry.user_id?.id || matchingEntry.user_id;
            
            let modifiedentry = {
              ...matchingEntry,
              user_id: matchedUserId,
              userIDCommoent: "1234567898123",
              isNotify: isNotify.includes(userDocId),
              user_name: userName,
              email: userEmail,
            };
            
            matchingEntries.push(modifiedentry);
            const monthYearDocId = `${userDocId}_${dayjs().format("YYYYMMDDHHmmss")}`;
            const docRef = doc(DATABASE, "monthly_grpahs", monthYearDocId);
            await setDoc(docRef, modifiedentry);
            setIsLoadingProgress((prev) => Math.min(prev + 10, 50));
            if (index === 0) {
              const selectedMonthName =
                values?.dayWisePerformance?.select_Month?.format("MMYY");
              const monthly_graph = "monthly_graphs";
              const globalGraphsMonthlyDocRef = doc(
                DATABASE,
                "global_data",
                monthly_graph,
                "graphs",
                `${selectedMonthName}`
              );
              await setDoc(globalGraphsMonthlyDocRef, modifiedentry);
            }
            const {
              user_id,
              fiddux_commission,
              profit_to_user,
              gross_performance_percentage,
              balance_after_commission,
              percentage_after_commission,
              graph_month,
              graph_year,
              current_month_date,
            } = modifiedentry;
            
            // Get current net_balance - use same logic as net_balance update
            let currentNetBalance = 0;
            try {
              // First, try to find the document by doc_id field (in case document ID is different)
              const usersRef = collection(DATABASE, "users");
              const q = query(usersRef, where("doc_id", "==", user_id));
              const querySnapshot = await getDocs(q);
              
              if (!querySnapshot.empty) {
                // Found by doc_id field - use the actual document ID
                const userDocRef = doc(DATABASE, "users", querySnapshot.docs[0].id);
                const userData = await getDoc(userDocRef);
                if (userData.exists()) {
                  currentNetBalance = userData.data()?.net_balance || 0;
                }
              } else {
                // Try direct document ID lookup
                const userDocRef = doc(DATABASE, "users", user_id);
                const userData = await getDoc(userDocRef);
                if (userData.exists()) {
                  currentNetBalance = userData.data()?.net_balance || 0;
                }
              }
            } catch (error) {
              console.error(`Error fetching current net_balance for ${user_id}:`, error);
              currentNetBalance = 0;
            }
            
            // CRITICAL: Apply profit to current balance (don't overwrite with statement balance)
            // This preserves any transactions made after the closing month (e.g., Feb 1-2 when closing Jan)
            const finalBalance = currentNetBalance + parseFloat(profit_to_user);
            
            const ledgerDocId = `${user_id}_${dayjs().format("YYYYMMDDHHmmss")}`;
            multipleUsersLedgers.push({
              profit_loss_balance: parseFloat(profit_to_user),
              user_id,
              profit_loss_percent: gross_performance_percentage,
              date: finalLedgerDate || current_month_date,
              created_at: Timestamp.now(),
              doc_id: ledgerDocId,
              new_txn_amount: parseFloat(profit_to_user),
              previous_balance: currentNetBalance,
              current_balance: finalBalance,
              transection_type: 3,
            });
            const monthlyClosingDocId = `${user_id}_${dayjs().format("YYYYMMDDHHmmss")}`;
            monthly_closing_user?.push({
              admin_comission: fiddux_commission,
              closing_balance: balance_after_commission, // Statement balance (for reference)
              closing_month: graph_month,
              closing_year: graph_year,
              date: finalLedgerDate || Timestamp.now(),
              doc_id: monthlyClosingDocId,
              is_email_notified: true,
              percent: percentage_after_commission,
              profit_loss: parseFloat(profit_to_user),
              profit_loss_bool: true,
              user_id,
              user_performance: gross_performance_percentage,
              // Store IDs for precise rollback
              performance_ledger_id: ledgerDocId,
              performance_transaction_id: `${user_id}_${dayjs().format("YYYYMMDDHHmmss")}`, // Will be created below
            });
            transectionUsers.push({
              admin_commission: fiddux_commission,
              date: finalLedgerDate || current_month_date,
              request_status: 5,
              request_type: 2,
              notes: "",
              payment_receipt: "",
              user_id,
              remaining_balance: 0,
              profit_loss: parseFloat(profit_to_user),
              total_amount: 0,
              profit_loss_percent: gross_performance_percentage,
              request_approval_time: finalLedgerDate || current_month_date,
              transection_fee: 0,
              txn_id: Number(dayjs()?.format("YYYYMMDDHHmmss")),
              withdraw_amount: 0,
              otp: "0",
              otp_verify: true,
              doc_id: `${user_id}_${dayjs().format("YYYYMMDDHHmmss")}`,
            });
            return Promise.resolve();
          }
        );
        await Promise.all(setDocPromises);
        setIsLoadingProgress(60);
        const netBalanceUpdatePromises = multipleUsersLedgers?.map(
          async ({ user_id, current_balance }) => {
            if (current_balance !== undefined) {
              try {
                // First, try to find the document by doc_id field (in case document ID is different)
                const usersRef = collection(DATABASE, "users");
                const q = query(usersRef, where("doc_id", "==", user_id));
                const querySnapshot = await getDocs(q);
                
                let userDocRef;
                if (!querySnapshot.empty) {
                  // Found by doc_id field - use the actual document ID
                  userDocRef = doc(DATABASE, "users", querySnapshot.docs[0].id);
                } else {
                  // Try direct document ID lookup
                  userDocRef = doc(DATABASE, "users", user_id);
                  const docSnap = await getDoc(userDocRef);
                  if (!docSnap.exists()) {
                    console.warn(`⚠️ User document not found for user_id: ${user_id}. Skipping net_balance update.`);
                    return; // Skip this user
                  }
                }
                
                // CRITICAL: Update net_balance with final balance (current + profit)
                // This preserves any transactions made after the closing month
                const updateNetBalance = { net_balance: current_balance };
                await updateDoc(userDocRef, updateNetBalance);
                console.log(`✅ Updated net_balance for user: ${user_id} to $${current_balance.toFixed(2)}`);
              } catch (error) {
                console.error(`❌ Error updating net_balance for user ${user_id}:`, error);
                // Don't throw - continue with other users
              }
            }
          }
        );
        // Create global yearly graph entry (one per month for entire fund)
        const yearlyPromise = (async () => {
          try {
            const currentMonth = values.dayWisePerformance.select_Month.month() + 1;
            const currentYear = values.dayWisePerformance.select_Month.year();

            // Porcentagem do FUNDO: soma dos dias digitados na 1ª tela.
            // Nunca usar gross_performance_percentage de um cliente — esse valor é
            // lucro ÷ saldo daquele cliente e muda com depósito/saque no mês.
            const selectDays = values?.dayWisePerformance?.select_days || [];
            const fundFromDays = selectDays.reduce(
              (acc, dayData) => acc + (parseFloat(dayData?.percentage) || 0),
              0
            );
            const fundFromEntry = parseFloat(multipleUsersEntryList?.[0]?.total_Monthly_percantage);
            const totalMonthlyPercentage = selectDays.length > 0 ? fundFromDays : fundFromEntry;

            if (!Number.isFinite(totalMonthlyPercentage)) {
              console.error(`⚠️ Yearly graph: porcentagem do fundo ausente para ${currentMonth}/${currentYear}. Não gravado.`);
              return;
            }

            console.log(`📊 Yearly graph usa a % do fundo: ${totalMonthlyPercentage}% para ${currentMonth}/${currentYear}`);
            
            // CRITICAL: Round to 2 decimals to avoid "números quebrados" (1.3059464464 → 1.31)
            // Floating-point accumulation from daily percentages produces long decimals.
            // Storing rounded value ensures Yearly Graph and Flutter app display 1.31% consistently.
            const roundedAmount = Math.round(totalMonthlyPercentage * 100) / 100;
            
            const yearlyGraphCollection = collection(DATABASE, "yearly_graph");
            
            // Check if global entry already exists for this month/year
            const querySnapshot = await getDocs(
              query(
                yearlyGraphCollection,
                where("month", "==", currentMonth),
                where("year", "==", currentYear)
              )
            );

            if (!querySnapshot.empty) {
              const existingEntry = querySnapshot.docs[0].data();
              // Verify point field exists and is valid
              if (!existingEntry.point && existingEntry.point !== 0) {
                console.warn(`⚠️ Yearly graph entry for ${currentMonth}/${currentYear} exists but missing point field`);
              } else {
                console.log(`✅ Yearly graph entry for ${currentMonth}/${currentYear} already exists. Skipping...`);
                return;
              }
            }
            
            // Get ALL previous entries to calculate running total
            console.log(`📊 Calculating running total for ${currentMonth}/${currentYear}...`);
            const allEntriesSnapshot = await getDocs(yearlyGraphCollection);
            
            const previousEntries = [];
            allEntriesSnapshot.forEach((doc) => {
              const data = doc.data();
              const entryDate = data.year * 100 + data.month;
              const currentDate = currentYear * 100 + currentMonth;
              
              if (entryDate < currentDate) {
                previousEntries.push({
                  month: data.month,
                  year: data.year,
                  amount: data.amount
                });
              }
            });
            
            // Calculate running total from ALL previous months
            // Point = cumulative sum of all previous months' amounts + current month's amount
            // This creates a smooth upward trending line graph
            let runningTotal = 0;
            previousEntries.forEach((entry) => {
              runningTotal += entry.amount || 0;
            });
            
            console.log(`   Previous months: ${previousEntries.length}`);
            console.log(`   Running total before this month: ${runningTotal.toFixed(4)}%`);
            console.log(`   This month's performance: ${roundedAmount}% (rounded from ${totalMonthlyPercentage.toFixed(4)}%)`);
            
            // Add current month's performance to running total (use rounded for consistency)
            runningTotal += roundedAmount;
            
            console.log(`   ✅ New cumulative point: ${runningTotal.toFixed(4)}%`);
            
            // Create the yearly graph entry
            // amount: Monthly performance percentage, rounded to 2 decimals (e.g., 1.31 for 1.31%)
            // point: Cumulative sum from first month to current month (for smooth upward trending graph)
            const yearlyData = {
              month: currentMonth,
              year: currentYear,
              amount: roundedAmount, // Rounded to 2 decimals to avoid display issues
              point: runningTotal, // Cumulative percentage (e.g., 62.75 + 1.31 = 64.06)
              created_at: Timestamp.now(),
            };
            
            const autoIDRef = await addDoc(yearlyGraphCollection, yearlyData);
            await setDoc(autoIDRef, { ...yearlyData, doc_id: autoIDRef.id });
            
            console.log(`✅ Created yearly graph entry: ${autoIDRef.id}`);
            
            // Update consolidated document
            try {
              const { updateYearlyGraphSummary } = await import("../../../../services/yearlyGraphService");
              // amount: rounded to 2 decimals (e.g., 1.31 for 1.31%)
              await updateYearlyGraphSummary({
                year: currentYear,
                month: currentMonth,
                amount: roundedAmount,
                point: runningTotal, // Cumulative percentage (e.g., 63.53 for 63.53%)
                created_at: Timestamp.now(),
                // NO individual_percentage - only use amount field
                doc_id: autoIDRef.id
              });
              console.log(`✅ Updated consolidated document for ${currentMonth}/${currentYear}`);
            } catch (consolidatedError) {
              console.error("❌ Error updating consolidated document:", consolidatedError);
              // Don't fail the whole operation if consolidated update fails
            }
          } catch (error) {
            console.error('❌ Error creating yearly graph entry:', error);
          }
        })();
        
        const yearlyPromises = [yearlyPromise];
        await Promise.all(yearlyPromises);
        
        // Update net_balance with error handling - don't fail if some users can't be updated
        try {
        await Promise.all(netBalanceUpdatePromises);
        } catch (error) {
          console.error('❌ Some net_balance updates failed, but continuing with closure process:', error);
          // Don't throw - continue with saving monthly_closings
        }
        
        setIsLoadingProgress(80);
        if (multipleUsersEntryList?.length > 0) {
          const saveLedgerPromises = multipleUsersLedgers?.map(
            async (ledger) => {
              const docRef = doc(DATABASE, "ledgers", ledger?.doc_id);
              await setDoc(docRef, ledger);
            }
          );
          await Promise.all(saveLedgerPromises);
          const saveTransectionPromises = transectionUsers?.map(
            async (trans) => {
              const docRef = doc(
                DATABASE,
                "transection_requests",
                trans?.doc_id
              );
              await setDoc(docRef, trans);
            }
          );
          await Promise.all(saveTransectionPromises);
          
          // CRITICAL: Save monthly_closings - this is what the Rollback Tool uses
          const saveMonthlyClosingPromises = monthly_closing_user?.map(
            async (m) => {
              try {
              const docRef = doc(DATABASE, "monthly_closings", m?.doc_id);
              await setDoc(docRef, m);
                console.log(`✅ Saved monthly_closing for user: ${m?.user_id}`);
              } catch (error) {
                console.error(`❌ Error saving monthly_closing for user ${m?.user_id}:`, error);
                // Don't throw - continue with other users
              }
            }
          );
          await Promise.all(saveMonthlyClosingPromises);
          console.log(`✅ Saved ${monthly_closing_user?.length || 0} monthly_closings records`);
          setIsLoadingProgress(90);
        }
        try {
          const selectedMonth = values?.dayWisePerformance?.select_Month
          console.log('📧 Sending PDF generation request for', isNotify?.length || 0, 'users...');
          
          const pdfResponse = await axios.post(
            FUNCTIONS_URLS.SendPdfMonthlyPerformance,
            { matchingEntries, isNotify, selectedMonth },
            { 
              headers: { 'Content-Type': 'application/json' },
              timeout: 300000 // 5 minutes timeout to match Cloud Function
            }
          );
          
          console.log('✅ PDF generation completed:', pdfResponse.data);
          
          // Send admin summary email after PDFs are sent
          try {
            const selectedMonthFormatted = values?.dayWisePerformance?.select_Month?.format('YYYY-MM');
            const closedClients = matchingEntries.map(entry => {
              // Try multiple possible field names for user name
              const userName = entry.user_name || 
                               entry.full_name || 
                               entry.name || 
                               entry.email || 
                               'Unknown';
              // Try multiple possible field names for email
              const userEmail = entry.email || '';
              
              return {
                full_name: userName,
                email: userEmail,
                closing_balance: entry.balance_after_commission || 0,
                profit_loss: entry.profit_to_user || 0,
                performance_percent: entry.gross_performance_percentage || 0
              };
            });
            
            const pdfSentClients = matchingEntries
              .filter(entry => isNotify.includes(entry.user_id))
              .map(entry => ({
                full_name: entry.user_name || entry.email || 'Unknown',
                email: entry.email || ''
              }));
            
            // Calculate total profit/loss by user type
            // First, build a map of user_id -> user_type from values?.select_user
            const userTypeMap = new Map();
            if (values?.select_user) {
              values.select_user.forEach(user => {
                const userId = user?.doc_id || user;
                const userType = user?.user_type;
                if (userType !== undefined) {
                  userTypeMap.set(userId, userType);
                }
              });
            }
            
            // Fetch user types for any users not found in select_user
            const usersToFetch = matchingEntries
              .map(entry => entry.user_id)
              .filter(userId => !userTypeMap.has(userId));
            
            if (usersToFetch.length > 0) {
              const userTypePromises = usersToFetch.map(async (userId) => {
                try {
                  const userDocRef = doc(DATABASE, "users", userId);
                  const userDocSnap = await getDoc(userDocRef);
                  if (userDocSnap.exists()) {
                    const userData = userDocSnap.data();
                    return { userId, userType: userData?.user_type };
                  }
                } catch (error) {
                  console.error(`Error fetching user_type for ${userId}:`, error);
                }
                return { userId, userType: undefined };
              });
              
              const userTypeResults = await Promise.all(userTypePromises);
              userTypeResults.forEach(({ userId, userType }) => {
                if (userType !== undefined) {
                  userTypeMap.set(userId, userType);
                }
              });
            }
            
            // Now calculate totals by user type
            let individualProfitLoss = 0;
            let corporateProfitLoss = 0;
            let individualCount = 0;
            let corporateCount = 0;
            let unknownCount = 0;
            const unknownUsers = [];
            
            const totalProfitLoss = matchingEntries.reduce((sum, entry) => {
              const profitLoss = parseFloat(entry.profit_to_user) || 0;
              const userDocId = entry.user_id;
              const userType = userTypeMap.get(userDocId);
              
              if (userType === 0) {
                individualProfitLoss += profitLoss;
                individualCount++;
              } else if (userType === 1) {
                corporateProfitLoss += profitLoss;
                corporateCount++;
              } else {
                // Unknown type - log for debugging
                unknownCount++;
                unknownUsers.push({
                  userId: userDocId,
                  userName: entry.user_name || entry.email || 'Unknown',
                  profitLoss: profitLoss,
                  userType: userType
                });
                // Treat as individual for consistency (same as rollback)
                individualProfitLoss += profitLoss;
                individualCount++;
              }
              
              return sum + profitLoss;
            }, 0);
            
            console.log('📧 Sending admin summary email...');
            console.log(`   Individual: ${individualCount} clients, Profit/Loss: $${individualProfitLoss.toFixed(2)}`);
            console.log(`   Corporate: ${corporateCount} clients, Profit/Loss: $${corporateProfitLoss.toFixed(2)}`);
            console.log(`   Total clients: ${matchingEntries.length} (Individual: ${individualCount}, Corporate: ${corporateCount}, Unknown: ${unknownCount})`);
            console.log(`   Total Profit/Loss: $${totalProfitLoss.toFixed(2)}`);
            
            if (unknownUsers.length > 0) {
              console.log(`   ⚠️ Users with unknown/null user_type (treated as individual):`, unknownUsers);
            }
            
            // DEBUG: Compare with multipleUsersEntryList
            console.log('🔍 DEBUG: Comparing with multipleUsersEntryList...');
            console.log(`   multipleUsersEntryList length: ${multipleUsersEntryList?.length || 0}`);
            console.log(`   matchingEntries length: ${matchingEntries.length}`);
            console.log(`   Difference: ${(multipleUsersEntryList?.length || 0) - matchingEntries.length} users processed but not selected`);
            
            // Calculate what tela 3 would show (all processed users)
            let tela3Individual = 0;
            let tela3Corporate = 0;
            let tela3IndividualCount = 0;
            let tela3CorporateCount = 0;
            
            if (multipleUsersEntryList && values?.select_user) {
              // Build user type map from select_user
              const tela3UserTypeMap = new Map();
              values.select_user.forEach(user => {
                const userId = user?.doc_id || user;
                const userType = user?.user_type;
                if (userType !== undefined) {
                  tela3UserTypeMap.set(userId, userType);
                }
              });
              
              // Fetch missing user types
              const tela3UsersToFetch = multipleUsersEntryList
                .map(entry => entry.user_id?.doc_id || entry.user_id?.id)
                .filter(userId => !tela3UserTypeMap.has(userId));
              
              if (tela3UsersToFetch.length > 0) {
                const tela3UserTypePromises = tela3UsersToFetch.map(async (userId) => {
                  try {
                    const userDocRef = doc(DATABASE, "users", userId);
                    const userDocSnap = await getDoc(userDocRef);
                    if (userDocSnap.exists()) {
                      const userData = userDocSnap.data();
                      return { userId, userType: userData?.user_type };
                    }
                  } catch (error) {
                    console.error(`Error fetching user_type for ${userId}:`, error);
                  }
                  return { userId, userType: undefined };
                });
                
                const tela3UserTypeResults = await Promise.all(tela3UserTypePromises);
                tela3UserTypeResults.forEach(({ userId, userType }) => {
                  if (userType !== undefined) {
                    tela3UserTypeMap.set(userId, userType);
                  }
                });
              }
              
              // Calculate totals for all processed users
              multipleUsersEntryList.forEach(entry => {
                const userId = entry.user_id?.doc_id || entry.user_id?.id;
                const profitLoss = parseFloat(entry.profit_to_user || 0);
                const userType = tela3UserTypeMap.get(userId);
                
                if (userType === 0 || userType === null || userType === undefined) {
                  tela3Individual += profitLoss;
                  tela3IndividualCount++;
                } else if (userType === 1) {
                  tela3Corporate += profitLoss;
                  tela3CorporateCount++;
                }
              });
            }
            
            console.log('📊 DEBUG: Tela 3 calculation (all processed users):');
            console.log(`   Individual: ${tela3IndividualCount} clients, Total: $${tela3Individual.toFixed(2)}`);
            console.log(`   Corporate: ${tela3CorporateCount} clients, Total: $${tela3Corporate.toFixed(2)}`);
            console.log(`   Grand Total: $${(tela3Individual + tela3Corporate).toFixed(2)}`);
            console.log('📊 DEBUG: Email calculation (selected users only):');
            console.log(`   Individual: ${individualCount} clients, Total: $${individualProfitLoss.toFixed(2)}`);
            console.log(`   Corporate: ${corporateCount} clients, Total: $${corporateProfitLoss.toFixed(2)}`);
            console.log(`   Grand Total: $${totalProfitLoss.toFixed(2)}`);
            console.log(`📊 DEBUG: Difference: Individual: $${(tela3Individual - individualProfitLoss).toFixed(2)}, Corporate: $${(tela3Corporate - corporateProfitLoss).toFixed(2)}, Total: $${((tela3Individual + tela3Corporate) - totalProfitLoss).toFixed(2)}`);
            
            await axios.post(
              FUNCTIONS_URLS.SendAdminEmailPerformance,
              {
                selectedMonth: selectedMonthFormatted,
                closedClients: closedClients,
                pdfSentClients: pdfSentClients,
                totalClients: matchingEntries.length,
                totalProfitLoss: totalProfitLoss,
                individualProfitLoss: individualProfitLoss,
                corporateProfitLoss: corporateProfitLoss
              },
              {
                headers: { 'Content-Type': 'application/json' },
                timeout: 30000 // 30 seconds timeout
              }
            );
            console.log('✅ Admin summary email sent successfully');
          } catch (emailError) {
            console.error('❌ Admin summary email error:', emailError?.message || emailError);
            // Don't fail the entire submission if admin email fails
            toast.warning('Monthly closing completed, but admin summary email may not have been sent.');
          }
        } catch (error) {
          console.error('❌ PDF generation error:', error?.message || error);
          // Don't fail the entire submission if PDF generation fails
          toast.warning('Monthly closing saved, but some PDFs may not have been sent. Check console for details.');
        }
        setIsLoadingProgress(100);
        toast.success("Monthly Graph Added Successfully!");

      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("Failed to add Monthly Graph.");
      } finally {
        setIsLoading(false);
        setTimeout(() => setIsLoadingProgress(0), 500);
        resetForm();
        setActiveStep(0);
        sessionStorage.removeItem("activeStep");
        navigate(-1);
      }
    },
  });
  // Removed repetitive console.log - was causing performance issues

  useEffect(() => {
    if (activeStep == 2 || activeStep == 0) {
      getLedgersList();
    }
  }, [activeStep, formik.values.dayWisePerformance.select_Month]);
  useEffect(() => {
    if (activeStep === 0) {
      sessionStorage.setItem(
        "select_Month",
        formik.values.dayWisePerformance.select_Month.toISOString()
      );
      sessionStorage.setItem(
        "select_days",
        JSON.stringify(formik.values.dayWisePerformance.select_days)
      );
    } else if (activeStep === 2) {
      sessionStorage.setItem(
        "select_user",
        JSON.stringify(formik.values.select_user)
      );
    }
  }, [formik.values, activeStep]);
  return (
    <Fragment>
      <TopHeader
        title={"Add Monthly"}
        onClick={() => {
          navigate(-1);
          sessionStorage.clear();
        }}
      />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit();
          return false;
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {isLoadingProgress > 0 && isLoadingProgress < 100 ? (
            <Box
              sx={{
                position: "fixed",
                inset: 0,
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                overflow: "hidden",
                height: "100vh",
              }}
            >
              <LinearProgress
                variant="determinate"
                value={isLoadingProgress}
                sx={{ width: "80%", borderRadius: "5px", marginBottom: 2 }}
              />
              <Typography
                variant="body1"
                sx={{
                  color: "#fff",
                  fontWeight: 600,
                  textAlign: "center",
                  fontSize: 20,
                }}
              >
                Please wait while we process your request.
              </Typography>
            </Box>
          ) : null}
          <Box
            sx={{
              maxWidth: { xs: "95%", lg: "95%", xl: "95%" },
              width: "100%",
              p: 3,
              margin: "50px auto 20px auto",
            }}
          >
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              sx={{ padding: "12px", width: "500px", margin: "0 auto" }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <Box sx={{ paddingTop: "32px" }}>
              {activeStep === 0 && (
                <DayWisePerformance
                  dayWisePerformance={formik?.values?.dayWisePerformance}
                  setFieldValue={formik?.setFieldValue}
                  errors={formik.errors.dayWisePerformance?.select_days}
                  touched={formik.touched.dayWisePerformance?.select_days}
                  total_Monthly_percantage={total_Monthly_percantage}
                  setTotal_monthly_percantage={setTotal_monthly_percantage}
                />
              )}
              {activeStep === 1 && (
                <PerformanceDailyGraph
                  dayWisePerformance={formik?.values?.dayWisePerformance}
                  multipleUsersEntryList={multipleUsersEntryList[0]}
                />
              )}
              {activeStep === 2 && (
                <CustomerSelection
                  multipleUsersEntry={multipleUsersEntryList}
                  setMultipleUsersEntryList={setMultipleUsersEntryList}
                  select_user={formik?.values?.select_user}
                  setFieldValue={formik?.setFieldValue}
                  total_Monthly_percantage={total_Monthly_percantage}
                  setIsNotify={setIsNotify}
                  isNotify={isNotify}
                  dayWisePerformance={formik?.values?.dayWisePerformance}
                />
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gridGap: "10px",
                pt: 1,
              }}
            >
              <IconButton
                onClick={handleBack}
                disabled={activeStep === 0}
                sx={{
                  background:
                    "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                  color: "#FFFFFF",
                  "&:hover": {
                    background:
                      "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                    color: "#FFFFFF",
                  },
                  "&.Mui-disabled": {
                    background: "#B0BEC5",
                    color: "#FFFFFF",
                  },
                }}
              >
                <KeyboardArrowLeftIcon />
              </IconButton>
              {activeStep !== 2 && (
                <IconButton
                  onClick={handleNext}
                  disabled={
                    !isStepValid(activeStep) || activeStep === steps.length - 1
                  }
                  sx={{
                    background:
                      "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                    color: "#FFFFFF",
                    "&:hover": {
                      background:
                        "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                      color: "#FFFFFF",
                    },
                    "&.Mui-disabled": {
                      background: "#B0BEC5",
                      color: "#FFFFFF",
                    },
                  }}
                >
                  <KeyboardArrowRightIcon />
                </IconButton>
              )}
              {activeStep === 2 && (
                <Button
                  type={"Submit"}
                  disabled={!isFormValid()}
                  sx={{
                    fontWeight: "700",
                    fontSize: "18px",
                    height: "48px",
                    maxWidth: "150px",
                    width: "100%",
                    textTransform: "unset",
                    background:
                      "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                    color: "#ffffff !important",
                    border: "1.5px solid #0C2C50",
                    "&:hover": {
                      border: "1.5px solid #0C2C50",
                      backgroundColor: "transparent !important",
                      color: "#ffffff !important",
                    },
                    "&.Mui-disabled": {
                      background: "#B0BEC5",
                      color: "#FFFFFF",
                      border: "1.5px solid #B0BEC5",
                    },
                  }}
                  className={"customBtn"}
                >
                  {isLoading ? (
                    <>
                      <CircularProgress />
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </form>
    </Fragment>
  );
};

export default AddMonthlyGraph;
